import { api } from "@/lib/axios";

export default function registerAction({
  id,
  action,
}: {
  id: string;
  action: string;
}) {
  return api.put(`deals/action/${id}`, {
    action,
  });
}
